import { useEffect } from 'react';
import { useSession } from 'next-auth/react';
import { useAnalytics } from '@contexts/use-analytics';
import { Session } from 'next-auth';

export function SessionHandler() {
  const { data: session } = useSession();
  const { emitSignUpEvent } = useAnalytics();

  const handleFirstSession = (session: Session) => {
    const storageKey = `__savvy_first_session_handled_${session.user.id}`;
    if (localStorage.getItem(storageKey) !== 'true') {
      emitSignUpEvent(session.user);
      localStorage.setItem(storageKey, 'true');
    }
  };

  useEffect(() => {
    if (session?.user?.id && session.isFirstSession) {
      handleFirstSession(session);
    }
  }, [session, emitSignUpEvent]);

  return null;
}
